import { z } from "zod";

import { excludeBasicFields } from "./excludeBasicFields";

export const makeUpdateInputSchema = <T extends z.ZodObject<z.ZodRawShape>>(schema: T) => {
  const cleanedSchema = excludeBasicFields(schema);

  return cleanedSchema.deepPartial();
};
